/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 8/10/19
 * Time: 10:37 AM
 */
import React, {Component} from 'react';
import {Grid, Placeholder, Segment} from 'semantic-ui-react'
import {Col, Row} from "reactstrap";

class App extends Component {
  state = {
    dummy: [1, 2, 3]
  };

  render() {
    const {data} = this.props;
    return (
      <Row style={{width: '100%', height: '100%'}}>
        {
          data !== undefined ?
            data.map((element, index) => (
              <Col key={index}>
                <Segment raised style={{width: '100%', height: '100%'}}>
                  <br/>
                  <Placeholder>
                    <Placeholder.Header image>
                      <Placeholder.Line/>
                      <Placeholder.Line/>
                    </Placeholder.Header>
                    <Placeholder.Paragraph>
                      <Placeholder.Line length='medium'/>
                      <Placeholder.Line length='short'/>
                    </Placeholder.Paragraph>
                  </Placeholder>
                </Segment>
                <br/>
              </Col>
            )) : null
        }
      </Row>

    );
  }
}

export default App;
